class PySerpRequest {
    constructor() {
        window.s1search = window.s1search || function () { (window.s1search.q = window.s1search.q || []).push(arguments); };
        this.searchFn = window.s1search.bind(window, 'config');

        this.promise = null;
    } 
    
    execute(serpQuery) {
        // eslint-disable-next-line no-console
        console.info('query:', serpQuery);
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            serpQuery.onComplete = this.onComplete.bind(this);
            serpQuery.onError = this.onError.bind(this);
            this.searchFn(serpQuery);
        });
    }

    onComplete(details) {
        this.resolve(details);
    }

    onError(details) {
        this.reject(details);
    }
}

export default PySerpRequest;